<template>
  <div v-if="facebookCampaign">
    <div class="flex justify-between">
      <span
        :class="{
          'inline-block': true,
          'bg-gray-200': true,
          'px-3': true,
          'py-1': true,
          'leading-snug': true,
          rounded: true,
          'text-xs': true,
          'text-gray-900': true,
          capitalize: true,
          'font-medium': true,
          'select-none': true,
          'mb-2': true,
        }"
      >
        Facebook Campaign
      </span>

      <span
        :class="{
          'inline-block': true,
          'bg-green-200': facebookCampaign.status === 'ACTIVE',
          'bg-gray-200': facebookCampaign.status !== 'ACTIVE',
          'px-3': true,
          'py-1': true,
          'leading-snug': true,
          rounded: true,
          'text-xs': true,
          'text-green-900': facebookCampaign.status === 'ACTIVE',
          'text-gray-900': facebookCampaign.status !== 'ACTIVE',
          capitalize: true,
          'font-medium': true,
          'select-none': true,
          'mb-2': true,
        }"
      >
        {{ facebookCampaign.status }}
      </span>
    </div>

    <div class="mt-2">
      <span class="block font-medium text-sm capitalize text-gray-600">Καμπάνια</span>
      {{ facebookCampaign.name }}
    </div>
    <div class="mt-4">
      <ul>
        <li class="flex justify-between">
          <span class="block font-medium text-sm capitalize text-gray-600">Immpressions</span>
          {{ impressions }}
        </li>

        <li class="flex justify-between mt-2">
          <span class="block font-medium text-sm capitalize text-gray-600">Reach</span>
          {{ reach }}
        </li>

        <li class="flex justify-between mt-2">
          <span class="block font-medium text-sm capitalize text-gray-600">Frequency</span>
          {{ frequency }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { sumBy, meanBy } from 'lodash-es';
import Numbro from '@/utils/numbro';

export default {
  name: 'ChannableFacebookCampaign',
  props: {
    facebookCampaign: {
      type: Object,
      default: null,
    },
  },
  computed: {
    insights() {
      return this.facebookCampaign?.facebookCampaignInsights || [];
    },
    aggregatedInsights() {
      return {
        impressions: sumBy(this.insights, 'impressions'),
        reach: sumBy(this.insights, 'reach'),
        frequency: meanBy(this.insights, 'frequency'),
        inlineLinkClicks: sumBy(this.insights, 'inlineLinkClicks'),
      };
    },
    impressions() {
      return this.formatNumber(this.aggregatedInsights.impressions);
    },
    reach() {
      return this.formatNumber(this.aggregatedInsights.reach);
    },
    inlineLinkClicks() {
      return this.formatNumber(this.aggregatedInsights.inlineLinkClicks);
    },
    frequency() {
      return Numbro(this.aggregatedInsights.frequency).format({ mantissa: 1 });
    },
  },

  methods: {
    formatNumber(value) {
      return Numbro(value).format({
        thousandSeparated: true,
        average: value > 100000,
        mantissa: value > 100000 ? 1 : 0,
      });
    },
  },
};
</script>
